/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Facebook = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M17.4102 4.65424H15.322C13.6814 4.65424 13.3831 5.4 13.3831 6.59322V9.05424H17.261V12.9322H13.3831V23H9.35593V13.0068H6V9.12881H9.35593V6.14576C9.35593 2.78983 11.4441 1 14.4271 1H17.4102V4.65424Z"
                        fill={color}
                    />
                </svg>
        );
    };
